module.exports = __webpack_public_path__ + "static/media/josefin2.41411145.webp";